<template>
  <div v-show="propRun"
       :id="`id_${propSeloItemOs.selo_id}`"
       @mouseover="showTooltip"
       @mouseleave="hideTootip">
    <b-button
      v-show="showBtn"
      v-b-modal="`modal_${propSeloItemOs.selo_id}`"
      variant="outline-primary btn-sm"
      :disabled="vinculacoes.length < 1"
      @click="item()">
      Vinculações
    </b-button>
    <span :class="[tooltip ? 'tooltipp tooltipp-active' : 'tooltipp']">Este selo não possui vinculações</span>

    <b-modal :id="`modal_${propSeloItemOs.selo_id}`"
             title="Selos vinculados"
             :header-bg-variant="propHeaderBgVariant"
             :header-text-variant="propHeaderTextVariant"
             size="xl">
      <table class="table">
        <tr>
          <th class="col-sm-2 pl-0 pr-0">
            <span class="boxOS_list_item boxOS_list_title font-weith">
              {{ vinculacoes.length > 1 ? 'Selos' : 'Selo' }}
            </span>
          </th>

          <th class="col-sm-2 text-center pl-0 pr-0">
            <span class="boxOS_list_item boxOS_list_title font-weith">
              Envio TJ
            </span>
          </th>

          <th class="col-sm-2 text-center pl-0 pr-0">
            <span class="boxOS_list_item boxOS_list_title font-weith">
              Cancelado TJ
            </span>
          </th>

          <th class="col-sm-2 text-center pl-0 pr-0">
            <span class="boxOS_list_item boxOS_list_title font-weith">
              Excluído TJ
            </span>
          </th>

          <th class="col-sm-2 text-center pl-0 pr-0">
            <span class="boxOS_list_item boxOS_list_title font-weith">
              Visualizar
            </span>
          </th>
          <th class="col-sm-2 text-center pl-0 pr-0">
            <span class="boxOS_list_item boxOS_list_title font-weith">
              QR Code
            </span>
          </th>
          <!--
          <th class="col-sm-2 text-center pl-0 pr-0">
            <span class="boxOS_list_item boxOS_list_title font-weith">
              Ações
            </span>
          </th> -->
        </tr>
        <tr v-for="(vinculado, index) in vinculacoes"
            :key="vinculado.vinculacao_selo_id"
            class="ListagemSelo_detailsBoxInfo_line_height"
            :class="{ 'ListagemSelo_border_bottom': index < vinculacoes.length - 1}">
          <td class="col-sm-2 pl-0 pr-0">
            {{ vinculado.seloVinculacao.num_selo }}
          </td>
          <td class="col-sm-2 text-center pl-0 pr-0">
            <!-- <span v-if="vinculado.data_envio_vinculacao_tj">
              {{ vinculado.data_envio_vinculacao_tj }}
            </span> -->
            <IconSvg class="mb-1"
                     :class="vinculado.data_envio_vinculacao_tj ? 'icon-done' : 'icon-close'"
                     :icon="vinculado.data_envio_vinculacao_tj ? 'done' : 'close2'" />
          </td>

          <td class="col-sm-2 text-center pl-0 pr-0">
            <span v-if="vinculado.seloVinculacao.cancelado_tj && vinculado.seloVinculacao.data_cancelamento">
              {{ vinculado.seloVinculacao.data_cancelamento }}
              <IconSvg class="mb-1 icon-done"
                       icon="done" />
            </span>
            <span v-else>
              -
            </span>
          </td>

          <td class="col-sm-2 text-center pl-0 pr-0">
            <span v-if="vinculado.seloVinculacao.excluido_tj">
              {{ vinculado.seloVinculacao.dataExcluido }}

              <IconSvg class="mb-1 icon-done"
                       icon="done" />
            </span>

            <span v-else>
              -
            </span>
          </td>

          <td class="col-sm-2 text-center pl-0 pr-0 mb-2">
            <div class="mb-1"
                 :class="{ 'mt-1': index > 0 }">
              <button class="btn btn-sm btn-outline-primary mr-2 col-6"
                      :disabled="!vinculado.data_envio_vinculacao_tj"
                      @click="acessarSeloTJ(vinculado.seloVinculacao.qrcode)">
                Acessar TJ
              </button>
            </div>
          </td>
          <td class="col-sm-2 text-center pl-0 pr-0 mb-2">
            <div class="mb-1"
                 :class="{ 'mt-1': index > 0 }">
              <BoxOsModalQrCode :disabled="!vinculado.data_envio_vinculacao_tj"
                                :prop-registro="propRegistro"
                                :prop-url="vinculado.seloVinculacao.qrcode" />
            </div>
          </td>
        </tr>
      </table>
      <template #modal-footer="{ ok }">
        <b-button size="sm"
                  variant="secondary"
                  @click="runDisable(), ok()">
          Fechar
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>

  import BoxOsModalQrCode from '@/components/SofiaRei/Resumo/OrdensServico/BoxOsModalQrCode.vue'

  export default {
    name: "BoxOsModal",
    components: {
      BoxOsModalQrCode,
    },
    props: {
      propRegistro: { type: Object, default: () => { return {} }},
      propSeloItemOs: { type: Object, default: () => { return {} }},
      propRun: { type: Boolean, default: false},
      showBtn: { type: Boolean, default: true},
      propHeaderBgVariant: { type: String, default: 'secondary' },
      propHeaderTextVariant: { type: String, default: 'white' },
    },
    data () {
      return {
        vinculacoes: this.propSeloItemOs.selo.vinculacoes,
        urlQrcodeModal: null,
        qrcodeModal: null,
        tooltip: false,
      }
    },
    methods: {
      acessarSeloTJ (qrcodeSelo) {
        window.open(qrcodeSelo)
      },
      showTooltip () {
        if (this.vinculacoes.length < 1)  this.tooltip = true
        setTimeout(() => {
          this.tooltip = false
        }, 2000)
      },
      hideTootip () {
        this.tooltip = false
      },
      runDisable () {
        this.$emit('runDisable')
      },
    }

  }
</script>

<style scoped>
  .icon-close {
    fill: #8b0000;
    width: 20px;
    height: 20px;
  }

  .icon-done {
    fill: #008b27;
    width: 20px;
    height: 20px;
  }

  .icon-close-disabled {
    fill: #d09898;
  }

  .icon-done-disabled {
    fill: #98d0a8;
  }
  .container {
    position:relative
  }
  .tooltipp {
      display: none;
      position: absolute;
      left: 140px;
      top: 0;
      min-width: 150px;
      z-index: 1;

      background-color: #F8F9FA;
      border-radius: .7rem;
      box-shadow: inset 0 0 0.1em rgba(0,0,0,.3);

      padding: .5rem;
      margin-left: 15px;
      margin-top: 15px;

      text-align: left;
      font-size: pxToRem(14);
      font-weight: 500;
      line-height: 1rem;
      color: black;
  }
  .tooltipp-active {
      display: block;
    }
    .tooltipp-active::after {
      content: '';
      position: absolute;
      top: 20%;
      right: 100%;
      transform: rotate(90deg);
      margin-left: 15px;
      border-width: 8px;
      border-style: solid;
      border-color: #F8F9FA transparent transparent transparent;
      box-shadow: solid 1px rgba(0,0,0,.3);



    }

</style>
